import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitInquiry = (data) => axios.post(`${API}/contact`, data);

export const adminLogin = (username, password) =>
  axios.post(`${API}/admin/login`, { username, password });

export const fetchInquiries = (password) =>
  axios.get(`${API}/inquiries`, { headers: { "X-Admin-Password": password } });

export const fetchStats = (password) =>
  axios.get(`${API}/stats`, { headers: { "X-Admin-Password": password } });

export const fetchLoginHistory = (password) =>
  axios.get(`${API}/admin/login-history`, {
    headers: { "X-Admin-Password": password },
  });

export const sendNote = (id, payload, password) =>
  axios.post(`${API}/inquiries/${id}/note`, payload, {
    headers: { "X-Admin-Password": password },
  });

export const downloadInvoice = (id, password) =>
  axios.get(`${API}/inquiries/${id}/invoice.pdf`, {
    headers: { "X-Admin-Password": password },
    responseType: "blob",
  });

export const updateInquiry = (id, status, password) =>
  axios.patch(`${API}/inquiries/${id}?status=${status}`, null, {
    headers: { "X-Admin-Password": password },
  });

export const deleteInquiry = (id, password) =>
  axios.delete(`${API}/inquiries/${id}`, {
    headers: { "X-Admin-Password": password },
  });
